import { render, staticRenderFns } from "./Rating.htm?vue&type=template&id=f0d9c3cc&scoped=true&"
import script from "./Rating.js?vue&type=script&lang=js&"
export * from "./Rating.js?vue&type=script&lang=js&"
import style0 from "./Rating.scss?vue&type=style&index=0&id=f0d9c3cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d9c3cc",
  null
  
)

export default component.exports